var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCovideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "background",
    fill: "#007BFF",
    d: "M0 0H64V64H0z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    className: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001C5E",
    d: "M21.994 37.928c2.99-2.444 5.434-5.517 7.17-9.014 2.238-4.105 2.835-8.944 1.663-13.492-1.655-5.686-7.284-9.113-12.935-7.876-.278 0-.573 0-.943.114.59-2.694 1.94-5.15 3.88-7.06.352-.264.789-.379 1.22-.322 9.804.467 17.514 8.774 17.499 18.852-.015 10.08-7.75 18.362-17.554 18.798",
    transform: "translate(12 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001C5E",
    d: "M21.657 30.814c-.569 2.57-1.813 4.927-3.598 6.817-.282.23-.643.334-1.001.286C7.624 37.217.246 29.259.006 19.523-.234 9.788 6.743 1.455 16.131.263c-.427.383-.723.65-1.002.936-5.47 5.12-8.034 12.754-6.806 20.259.442 2.956 2.013 5.608 4.364 7.365 2.352 1.758 5.287 2.474 8.154 1.991.272-.02.545-.02.816 0",
    transform: "translate(12 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8C21",
    d: "M15.101 19.177V14.07c0-1.695.657-1.883 1.917-1.186 2.84 1.676 5.678 3.372 8.482 5.086 1.154.697 1.154 1.507 0 2.204-2.875 1.771-5.75 3.504-8.66 5.219-1.047.621-1.774.244-1.774-1.018v-5.2",
    transform: "translate(12 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovideo);
export default __webpack_public_path__ + "static/media/covideo.75700ca69090c1ab19c7ca955275889e.svg";
export { ForwardRef as ReactComponent };